import { usePageFootnotes } from 'hooks/usePageFootnotes';
import { useRouter } from 'next/router';
import { useEffect } from 'react';

import { useAnalytics } from './useAnalytics';

export const useRouteChange = () => {
  const router = useRouter();
  const clearFootnotes = usePageFootnotes((state) => state.clearFootnotes);

  const { analytics } = useAnalytics();

  useEffect(() => {
    const handleRouteChangeStart = () => {
      clearFootnotes();
    };
    const handleRouteChangeComplete = (url: string) => {
      analytics.pageView({ url });
    };
    // When the component is mounted, subscribe to router changes and log those page views
    router.events.on('routeChangeStart', handleRouteChangeStart);
    router.events.on('routeChangeComplete', handleRouteChangeComplete);
    return () => {
      // If the component is unmounted, unsubscribe from the event with the `off` method
      router.events.off('routeChangeStart', handleRouteChangeStart);
      router.events.off('routeChangeComplete', handleRouteChangeComplete);
    };
  }, [analytics, router, clearFootnotes]);
};
